import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useSelector } from "react-redux";

const formatBalance = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  return `₹${Number(value).toLocaleString("en-IN")}`;
};

const formatDate = (value) => {
  if (!value) return "—";
  return dayjs(value).format("DD MMM YYYY, hh:mm A");
};

function Hubble() {
  const vht = useSelector((state) => state.qwickSilver);
  const response = vht?.data?.response;

  return (
    <Stack spacing={2}>
      <Stack spacing={1} direction="row">
        <Typography>Hubble Balance</Typography>
        <Typography color="primary">
          {formatBalance(response?.hubble_balance)}
        </Typography>
      </Stack>
      <Stack spacing={1} direction="row">
        <Typography>Last Hubble Order</Typography>
        <Typography color="primary">
          {formatBalance(response?.last_hubble_order_price)}
        </Typography>
      </Stack>
      <Stack spacing={1} direction="row">
        <Typography>Last Order At</Typography>
        <Typography color="primary">
          {formatDate(response?.last_hubble_order_at)}
        </Typography>
      </Stack>
    </Stack>
  );
}

export default Hubble;
